import { Check, X, Eye } from "lucide-react";
import AdminListingActions from "../../components/admin/AdminListingActions";
import AdminListToolbar from "../../components/admin/AdminListToolbar";
import AdminPagination from "../../components/admin/AdminPagination";
import { listingCoverImage } from "../../lib/fileUrl";

export default function AdminPendingVehiclesTab({
  pending,
  pendingSearchDraft,
  onPendingSearchDraftChange,
  onPendingSearch,
  pendingTotal,
  page,
  totalPages,
  onPageChange,
  onReview,
  onApprove,
  onReject,
  onDelete,
}) {
  return (
    <div className="zc-card overflow-hidden overflow-x-auto mt-4" data-testid="admin-pending">
      <AdminListToolbar
        draft={pendingSearchDraft}
        onDraftChange={onPendingSearchDraftChange}
        onSearch={onPendingSearch}
        placeholder="Search by make, model, owner, plate, VIN…"
        testid="admin-pending-search"
        total={pendingTotal}
        shown={pending.length}
      />
      {pending.length === 0 && <div className="px-4 sm:px-6 py-10 text-center text-[var(--zc-text-3)] text-sm">No pending listings.</div>}
      {pending.map(v => (
        <div key={v.vehicle_id} className="flex flex-col gap-3 sm:grid sm:grid-cols-[80px,1fr,auto] sm:items-center px-4 sm:px-6 py-4 border-b border-[var(--zc-border)] last:border-0">
          {v.images?.[0] ? <img src={listingCoverImage(v.images)} className="w-20 h-14 object-cover rounded shrink-0" alt="" /> : <div className="w-20 h-14 bg-[var(--zc-bg-3)] rounded shrink-0" />}
          <div className="min-w-0">
            <div className="zc-title text-lg">{v.year} {v.make} {v.model}</div>
            <div className="text-xs text-[var(--zc-text-3)]">{v.location_city} · ${v.daily_rate}/day · by {v.owner_name}</div>
            {(v.registration_number || v.vin) && (
              <div className="text-2xs font-mono text-[var(--zc-text-2)] mt-1 break-all">
                {v.registration_number && <span>Plate {v.registration_number}</span>}
                {v.registration_number && v.vin && " · "}
                {v.vin && <span>VIN {v.vin}</span>}
              </div>
            )}
          </div>
          <div className="flex flex-wrap gap-2 zc-stack-actions">
            <button onClick={() => onReview(v.vehicle_id)} className="px-3 h-9 zc-btn-ghost text-xs flex items-center gap-1" data-testid={`review-${v.vehicle_id}`}>
              <Eye size={12} /> Review
            </button>
            <button onClick={() => onApprove(v.vehicle_id)} className="px-3 h-9 zc-btn-primary text-xs flex items-center gap-1" data-testid={`approve-${v.vehicle_id}`}>
              <Check size={12} /> Approve
            </button>
            <button onClick={() => onReject(v.vehicle_id)} className="px-3 h-9 zc-btn-ghost text-xs flex items-center gap-1" data-testid={`reject-${v.vehicle_id}`}>
              <X size={12} /> Reject
            </button>
            <AdminListingActions
              compact
              item={{ ...v, type: "vehicle", listing_id: v.vehicle_id }}
              onDelete={onDelete}
              size="md"
            />
          </div>
        </div>
      ))}
      <AdminPagination page={page} totalPages={totalPages} onPageChange={onPageChange} testid="admin-pending-pagination" />
    </div>
  );
}
